var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout",staticStyle:{"margin-bottom":"11px"},attrs:{"name":"text-label"}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text)),(_vm.isDefault)?_c('span',{staticClass:"star"},[_vm._v("*")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b167f93c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/TextLabel.vue
// module id = null
// module chunks = 